import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {TENANT_MODULE_NAMESPACE, TENANT_GET_BLOCK_TENANTS} from '../../../store/tenant';
import {OWNER_MODULE_NAMESPACE, OWNER_GET_BLOCK_OWNERS} from '../../../store/owner';
import {BLOCK_MODULE_NAMESPACE, BLOCK_LOADERS, BLOCK_SET_LOADER_STATE} from '../../../store/block';
import {IBaseFilterParameter} from '../../../models/base-filter.parameter';
import {AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE} from '../../../store/authorization';
import {
  PROFILE_MODULE_NAMESPACE,
  PROFILE_EDIT_MEMBER,
  PROFILE_INIT_MEMBER_SELECTION,
  PROFILE_ACTION,
  PROFILE_DELETE_MEMBER,
  PROFILE_GET_ENTITY_ROLES, PROFILE_GET_CONTACT
} from '../../../store/profile/profile-types.store';
import {CrudStatus} from '../../../common/enums';
import {TranslateResult} from 'vue-i18n';

const TenantStore = namespace(TENANT_MODULE_NAMESPACE)
const OwnerStore = namespace(OWNER_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)

@Component({
  components: {
    'block-tenant-header': async () => import('../components/block-detail-header/BlockDetailHeader.vue'),
    'block-tenant-type': async () => import('../components/block-tenant-types-item/BlockTenantTypesItem.vue'),
    'sub-navigation-title-duplicate': async () => import('@/components/sub-navigation-title-duplicate/SubNavigationTitleDuplicate.vue'),
    'profile-table-loader': async () => import('@/containers/profile/loaders/profile-pagination-loader/ProfilePaginationLoader.vue'),
    'profile-delete-loader': async () => import('@/containers/profile/loaders/profile-delete-loader/ProfileDeleteLoader.vue')
  },
  filters: {
    acronym(value: string) {
      if (!value) return
      const [firstname, lastname] = value.trim().split(' ')
      if (!lastname) return firstname.slice(0, 2)
      return `${firstname[0]}${lastname[0]}`
    }
  }
})
class BlockApartmentsTenants extends Vue {
  dtActiveIndex: number;
  dtSearch: string;
  dtSource: any[];
  dtIsLoading: boolean;
  dtPage: number;
  dtTotalPage: number;
  dtMenu: boolean
  dtCurrentRole: any
  dtMessageErrorModel: boolean
  dtError: any
  dtClickedBtn: boolean

  constructor(prop) {
    super(prop);
    this.dtPage = 1;
    this.dtTotalPage = null;
    this.dtActiveIndex = 1;
    this.dtSearch = null;
    this.dtIsLoading = false;
    this.dtSource = [];
    this.dtMenu = false
    this.dtCurrentRole = null
    this.dtMessageErrorModel = false
    this.dtError = null
    this.dtClickedBtn = false
  }

  @TenantStore.Getter tenants: any;
  @OwnerStore.Getter owners: any;
  @BlockStore.Getter blockEntityParameter: IBaseFilterParameter & { q: string }
  @ProfileStore.Getter memberSelection: number[]
  @ProfileStore.Getter profileCrudActionStatus: CrudStatus
  @BlockStore.Getter loaders: Map<string, boolean>
  @ProfileStore.Getter entityRoles: any[]

  @TenantStore.Action(TENANT_GET_BLOCK_TENANTS)
  storeGetTenants: (payload: { param: any, blockId: string }) => Promise<any>;
  @OwnerStore.Action(OWNER_GET_BLOCK_OWNERS)
  storeGetOwners: (payload: { param: any, blockId: string }) => Promise<any>;
  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  @ProfileStore.Action(PROFILE_EDIT_MEMBER)
  storeEditMember: (memberId?: number) => Promise<any>
  @ProfileStore.Action(PROFILE_GET_ENTITY_ROLES)
  storeGetEntityRoles: (params: any) => Promise<any>
  @ProfileStore.Action(PROFILE_DELETE_MEMBER)
  storeDeleteMember: () => Promise<any>
  @ProfileStore.Action(PROFILE_GET_CONTACT)
  storeGetContact: (payload: any) => Promise<any>

  @ProfileStore.Mutation(PROFILE_INIT_MEMBER_SELECTION)
  storeInitMemberSelection: () => void
  /* @ProfileStore.Mutation(PROFILE_SET_MEMBER_SELECTION)
  storeSetMemberSelection: (memberId: number) => void */
  @ProfileStore.Mutation(PROFILE_ACTION)
  storeSetProfileAction: (action: CrudStatus) => void
  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  get searchParam() {
    return {
      $skip: (this.dtPage - 1) * 10,
      q: this.blockEntityParameter.q,
      block: this.$route.params.id,
      role: this.dtCurrentRole ? this.dtCurrentRole.id : null
    }
  }

  get coSource() {
    console.log('current source', this.dtSource)
    return this.dtSource || [];
  }

  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/profile').default
    }
  }

  get coCurrentEntityName() {
    if (!this.dtCurrentRole) return ''
    return this.dtCurrentRole.name
  }

  get coEntities() {
    return this.entityRoles.map(x => {
      x.key = x.role
      return x
    })
  }

  get coTableLoader() {
    return this.loaders.get(BLOCK_LOADERS.CONTACT)
  }

  get isOpenDeleteMessage(): boolean {
    return this.profileCrudActionStatus === CrudStatus.Delete
  }

  get displayRoleSelector() {
    return this.entityRoles.length > 1
  }

  created() {
    this.getRolesContact()
  }

  mounted() {}

  canEditContact(contact: any) {
    if (contact.role === 'tenant')
      return this.$route.meta['edit_tenant_account']
    else if (contact.role === 'owner')
      return this.$route.meta['edit_owner_account']
    return false
    /* TODO can be usefull in the future
    *   this.$route.meta['delete_tenant_account']
    *   this.$route.meta['delete_owner_account']
    *   this.$route.meta['delete_team_account']
    *  */
  }

  getRolesContact() {
    this.storeGetEntityRoles({type: 'block_contact'})
      .then(response => {
        this.dtCurrentRole = this.entityRoles[0]
        this.handleGetContact()
      })
  }

  handleGetContact(needReset: boolean = false) {
    this.storeSetLoaderState({key: BLOCK_LOADERS.CONTACT, value: true})
    if (needReset) {
      this.dtPage = 1;
    }
    this.storeGetContact(this.searchParam)
      .then(response => {
        console.log('CONTACTS =====', response)
        this.dtSource = response.data
        this.dtTotalPage = Math.ceil(response.total / 10)
        this.storeSetLoaderState({key: BLOCK_LOADERS.CONTACT, value: false})
      })
  }

  handleTenantItemClick(tenant: any) {
    if (this.dtCurrentRole.role !== 'tenant' && this.dtCurrentRole.role !== 'owner') return
    let path: string = `/block/${this.$route.params.id}/tenant/` + tenant;
    if (this.dtCurrentRole.role === 'owner')
      path = path.replace('tenant', 'owner');
    this.$router.push({
      path: path,
      params: {
        id: this.$route.params.id,
        cid: tenant
      }
    })
  }

  handleEditContact(id: number) {
    this.dtClickedBtn = true
    setTimeout(() => {
      this.dtClickedBtn = false
    }, 400)
    this.storeEditMember(id).then()
  }

  handleCloseErrorModal() {
    this.dtMessageErrorModel = false
    this.dtError = null
  }

  handleDeleteCancel() {
    this.storeInitMemberSelection()
    this.storeSetProfileAction(CrudStatus.NoAction)
  }

  @Watch('dtPage')
  handlePageChange(value: number) {
    this.handleGetContact()
  }

  _clearTimeout: any

  @Watch('searchParam.q')
  handleKeywordChanged(value: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.handleGetContact(true)
    }, 500);
  }

  handleEntityClick(event?: { data }) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtMenu = false
      if (event.data) {
        this.dtCurrentRole = event.data
      }
      this.handleGetContact()
    }, 300)
  }

  handleMemberClick(id: number) {
    if (this.dtClickedBtn) return
    this.handleTenantItemClick(id)
  }

  get coTableHeaders(): any[] {
    return [
      {
        //text: 'avatar',
        value: 'avatar',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.members_headers.fullname),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.members_headers.email),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.members_headers.tel_fix),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.members_headers.tel_portable),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        value: 'more',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title hidden'
      }
    ]
  }


  /* get IsLouisianeEnv() {
    return process.env.NODE_ENV === 'prelouisiane' || process.env.NODE_ENV === 'louisiane'
  } */

  // TODO => BELOW CODE TO DELETE MEMBERS FROM BLOCK CONTACT

  isMemberSelected(id: number): boolean {
    return this.memberSelection.indexOf(id) !== -1
  }

  /* get coProfileDelectionMessage(): TranslateResult {
    if (this.memberSelection.length === 1) {
      let user = this.coSource.find(contact => contact.id === this.memberSelection[0])
      return this.$t(this.lblSetting.profileDeleteMessage, {fullname: `${user.firstname} ${user.lastname}`.trim()})
    }
    if (this.memberSelection.length > 1)
      return this.$t(this.lblSetting.profileDeleteSelectionMessage)
    return ""
  } */

  /* handleDeleteContact(id: number) {
    this.dtClickedBtn = true
    setTimeout(() => {
      this.dtClickedBtn = false
    }, 400)
    console.log('delete contact id', id)
    this.storeInitMemberSelection()
    this.storeSetMemberSelection(id)
    this.storeSetProfileAction(CrudStatus.Delete)
  }*/

  /* handleDeleteOK() {
    this.dtIsLoading = true
    this.storeDeleteMember()
      .then(() => {
        this.storeInitMemberSelection()
        this.$router.go(0)
        //this.$router.replace(Uris.BlockIdContacts.replace(':id',this.$route.params.id))
      })
      .catch(err => {
        this.dtMessageErrorModel = true
        this.dtError = err
      })
      .finally(() => this.dtIsLoading = false)
  } */

  /* handleDeleteSelection() {
    if (this.memberSelection.length) this.storeSetProfileAction(CrudStatus.Delete)
  } */

  handleAvatarClick(id: number) {
    /* this.dtClickedBtn = true
    setTimeout(() => {
      this.dtClickedBtn = false
    }, 400) */
    // if (this.coMemberMenuAuths.deleteTeamAccount) this.storeSetMemberSelection(id)
  }

}

export default BlockApartmentsTenants;



// WEBPACK FOOTER //
// ./src/containers/block/block-tenants/index.ts